module.exports = __webpack_public_path__ + "media/img/why/endtoend-be59e87328cc39b49e8918bb98d3eca1.png";